export { default } from "./AppChip";
export type { AppChipProps } from "./AppChip";
